export type BasketUrlData = {
  products: {
    productId: string;
    quantity: number;
  }[];
  totalUrlLabel: string;
};

/**
 * Возвращает URL для отправки товаров в корзину
 * @param {BasketUrlData} data
 * @returns {string}
 */
export const getBasketHref = (data: BasketUrlData): string => {
  const productCountPair = data.products
    .reduce((acc: string, { productId, quantity }) => {
      acc += `${productId}:${quantity},`;
      return acc;
    }, '')
    .slice(0, -1);

  return `basket/?products=%22${productCountPair}%22&landing=${data.totalUrlLabel}`;
};
